import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import SignatureCanvas from 'react-signature-canvas';

import { CSSTransitionGroup } from 'react-transition-group';

import { compose } from 'redux';

import { formatPhone, toFriendlyDateString, toFriendlyDateTimeString } from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { MuiThemeProvider } from '@material-ui/core';
import Autorenew from '@material-ui/icons/HowToReg';
import { createMuiTheme } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Multiple from '@material-ui/icons/DoneAll';
import FlatButton from 'material-ui/FlatButton';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import { ParcelStatus } from 'components/shared/StatusHelper';
import Header from 'components/shared/Header';

import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';

import { saveSignature } from 'actions/landlordParcelsActions';

let style = {
  avatarStyle: {
    height: '120px',
    width: '120px',
    border: '0px solid #e1e1e1',
    backgroundSize: 'cover',
    float: 'right',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 0',
  },
  statusBadge: {
    display: 'inline',
    color: 'white',
    verticalAlign: 'middle',
    padding: '5px 5px 2px',
    marginLeft: '6px',
    fontSize: '50%',
  },
};

let ParcelDetails = class extends Component {
  render() {
    const { parcelDetails, showTenantDetails } = this.props;
    style = {
      ...style,
      avatarStyle: {
        ...style.avatarStyle,
        backgroundImage: 'url(' + deepDiver(parcelDetails, 'tenant_avatar') + ')',
      },
    };

    return (
      <Fragment>
        {showTenantDetails && (
          <div className="row" style={{ margin: '20px 0 35px' }}>
            <div className="col-xs-6">
              <Paper circle={true} style={style.avatarStyle} />
            </div>
            <div className="col-xs-6">
              <h4 style={{ margin: '8px 0 18px', fontFamily: 'Circular' }}>Parcel Pickup for</h4>
              <h4 style={{ marginTop: 0, fontFamily: 'Circular-Bold' }}>
                {parcelDetails.tenant_full_name}
              </h4>
              <h5 style={{ marginTop: 0 }}>{parcelDetails.tenant_email}</h5>
              <h5 style={{ marginTop: 0 }}>{formatPhone(parcelDetails.tenant_phone_number)}</h5>
            </div>
          </div>
        )}

        <div className="row">
          <Header name="PARCEL DETAILS" />

          <div className="row" style={{ paddingTop: '20px' }}>
            <div className="col-sm-6">
              <h5 style={{ margin: '0', textAlign: 'center' }}> Parcel Recorded By </h5>
              <h2 style={{ textAlign: 'center', marginTop: '15px' }}>
                {parcelDetails.received_by}
              </h2>
            </div>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <h5 style={{ margin: '0', textAlign: 'center' }}> Parcel Recorded At </h5>
              <p style={{ textAlign: 'center', marginTop: '15px' }}>
                {toFriendlyDateTimeString(parcelDetails.received_at)}
              </p>
            </div>
          </div>

          <div className="row" style={{ paddingTop: '20px' }}>
            <div className="col-sm-6">
              <h5 style={{ margin: '0', textAlign: 'center' }}> Parcel ID </h5>
              <h2 style={{ textAlign: 'center', marginTop: '15px' }}>{parcelDetails.uuid}</h2>
            </div>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <h5 style={{ margin: '0', textAlign: 'center' }}> Parcel Description/Notes </h5>
              <p style={{ textAlign: 'center', marginTop: '15px' }}>
                {parcelDetails.notes || 'None'}
              </p>
            </div>
          </div>

          {this.renderParcelPickedUpDetails(parcelDetails)}

          {this.renderMultipleParcelsWarning(parcelDetails)}

          <div className="row" style={{ paddingTop: '5px' }}>
            {this.renderSingleParcelSelection(parcelDetails)}
            {this.renderMultipleParcelSelection(parcelDetails)}
          </div>
        </div>
      </Fragment>
    );
  }

  renderParcelPickedUpDetails = parcelDetails => {
    if (!parcelDetails.released_at) {
      return;
    }

    return (
      <div className="row" style={{ paddingTop: '20px' }}>
        <div className="col-sm-6">
          <h5 style={{ margin: '0', textAlign: 'center' }}> Released On </h5>
          <h2 style={{ textAlign: 'center', marginTop: '15px' }}>
            {toFriendlyDateString(parcelDetails.released_at)}
          </h2>
        </div>
        <div className="col-sm-6" style={{ textAlign: 'center' }}>
          <h5 style={{ margin: '0', textAlign: 'center' }}> Released By </h5>
          <p style={{ textAlign: 'center', marginTop: '15px' }}>{parcelDetails.released_by}</p>
        </div>
        <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '25px' }}>
          <img alt="parcel signature" src={parcelDetails.signature_url} />
        </div>
      </div>
    );
  };

  renderMultipleParcelsWarning = parcelDetails => {
    const pendingParcels = parcelDetails.pending_parcels;

    if (parcelDetails.released_at || pendingParcels.length === 1) {
      return;
    }

    return (
      <div className="row" style={{ marginTop: '20px', padding: '0 15px' }}>
        <p style={{ textAlign: 'justify', maxWidth: '559px', margin: '0 auto 15px' }}>
          {' '}
          <i className="em em-raised_hands" />
          <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}> Heads Up! </b>
          <i className="em em-raised_hands" />
          &nbsp;It looks like {parcelDetails.tenant_full_name} has muliple parcels that need to be
          picked up.
        </p>
      </div>
    );
  };

  renderSingleParcelSelection = parcelDetails => {
    const pendingParcels = parcelDetails.pending_parcels;

    if (parcelDetails.released_at) {
      return;
    }

    const hasMultipleParcels = pendingParcels.length > 1;
    const columnSize = hasMultipleParcels ? '6' : '12';

    return (
      <div
        className={`col-xs-${columnSize}`}
        id="hover-select"
        style={{ marginTop: '15px' }}
        onClick={() => this.props.toggleReleaseParcelDialog([parcelDetails])}
      >
        <div
          style={{
            width: '85px',
            height: '85px',
            margin: 'auto',
            textAlign: 'center',
            borderRadius: '100px',
            border: `4px solid ${AccentColor()}`,
            cursor: 'pointer',
            paddingTop: '9px',
            paddingLeft: '3px',
          }}
        >
          <Autorenew style={{ color: AccentColor(), height: '55px', width: '55px' }} />
        </div>
        <p
          style={{
            textAlign: 'center',
            fontFamily: 'Circular-Bold',
            marginTop: '10px',
          }}
        >
          Release to <TenantResidentVerbiageHelper capitalize />
        </p>
      </div>
    );
  };

  renderMultipleParcelSelection = parcelDetails => {
    const pendingParcels = parcelDetails.pending_parcels;
    const parcelPickedUp = parcelDetails.released_at;
    const hasMultipleParcels = pendingParcels.length > 1;
    const columnSize = hasMultipleParcels ? '6' : '12';

    if (!hasMultipleParcels || parcelPickedUp) {
      return;
    }

    return (
      <div
        className={`col-xs-${columnSize}`}
        id="hover-select"
        style={{ marginTop: '15px' }}
        onClick={() => this.props.toggleReleaseParcelDialog(pendingParcels)}
      >
        <div
          style={{
            width: '85px',
            height: '85px',
            margin: 'auto',
            textAlign: 'center',
            borderRadius: '100px',
            border: `4px solid ${AccentColor()}`,
            cursor: 'pointer',
            paddingTop: '9px',
            paddingLeft: '3px',
          }}
        >
          <Multiple style={{ color: AccentColor(), height: '55px', width: '55px' }} />
        </div>
        <p
          style={{
            textAlign: 'center',
            fontFamily: 'Circular-Bold',
            marginTop: '10px',
          }}
        >
          Release Multiple to <TenantResidentVerbiageHelper capitalize />
        </p>
      </div>
    );
  };
};

let ReleaseParcelForm = class ReleaseParcelForm extends Component {
  constructor(props) {
    super(props);
    this.sigPad = {};
    this.state = {
      showReleaseParcel: false,
      allowSubmit: null,
      parcelsToReleaseIDs: [],
      selectedParcels: {},
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.parcelsToReleaseIDs &&
      nextProps.parcelsToReleaseIDs === this.props.parcelsToReleaseIDs
    )
      return;

    this.setState({
      parcelsToReleaseIDs: nextProps.parcelsToReleaseIDs.map(parcel => parcel.uuid),
    });
  }

  clear = () => {
    this.setState({ allowSubmit: false });
    this.sigPad.clear();
  };

  preventSubmitIfNeeded = () => {
    const parcelsToReleaseIDs = Object.keys(this.state.selectedParcels).filter(
      parcelUUID => this.state.selectedParcels[parcelUUID]
    );

    if (parcelsToReleaseIDs.length === 0) {
      this.setState({ allowSubmit: false });
    }
  };

  handleSelect = name => event => {
    this.setState(
      {
        selectedParcels: {
          ...this.state.selectedParcels,
          [name]: event.target.checked,
        },
      },
      this.preventSubmitIfNeeded()
    );
  };

  toggleReleaseParcelDialog = () => {
    this.setState({
      showReleaseParcel: false,
      allowSubmit: null,
      parcelsToReleaseIDs: [],
      selectedParcels: {},
    });
    this.props.toggleReleaseParcelDialog([]);
  };

  saveSignature = () => {
    this.setState({ allowSubmit: true });
    this.props.saveSignature(this.sigPad.getTrimmedCanvas().toDataURL('image/png'));
  };

  render() {
    const hasMultipleParcels = this.state.parcelsToReleaseIDs.length > 1;
    const parcelsToReleaseIDs = Object.keys(this.state.selectedParcels).filter(
      parcelUUID => this.state.selectedParcels[parcelUUID]
    );

    const showSignaturePad = !hasMultipleParcels || parcelsToReleaseIDs.length > 0;
    const parcelsForPickup = hasMultipleParcels
      ? parcelsToReleaseIDs
      : this.state.parcelsToReleaseIDs;

    const allowSubmit = hasMultipleParcels
      ? this.state.allowSubmit && parcelsForPickup.length > 0
      : this.state.allowSubmit;

    return (
      <Dialog
        disableBackdropClick
        fullScreen={this.props.fullScreen}
        open={this.props.isOpen}
        onClose={this.toggleReleaseParcelDialog}
        aria-labelledby="add-new-parcel"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <DialogTitle id="add-new-parcel">
          <h3 style={{ textAlign: 'center', margin: 0 }}>Parcel Release</h3>
        </DialogTitle>
        <DialogContent>
          <Fragment>
            {hasMultipleParcels && this.renderMultipleParcelSelection()}
            <CSSTransitionGroup
              transitionName="show_dropdown_266px"
              transitionEnterTimeout={300}
              transitionLeaveTimeout={300}
            >
              {showSignaturePad && this.renderSignToReleaseParcel()}
            </CSSTransitionGroup>
          </Fragment>
        </DialogContent>
        <DialogActions style={{ display: 'block', padding: '0 10px' }}>
          <FlatButton
            onClick={this.toggleReleaseParcelDialog}
            id="close-button"
            style={{ color: AccentColor(), padding: '0 15px', float: 'left' }}
          >
            CLOSE
          </FlatButton>
          <FlatButton
            onClick={() => this.props.releaseParcels(parcelsForPickup)}
            id="submit-button"
            disabled={!allowSubmit}
            style={{
              color: 'white',
              padding: '0 15px',
              backgroundColor: allowSubmit ? AccentColor() : colors.LIGHT_GRAY,
              float: 'right',
            }}
          >
            SAVE
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }

  renderSignToReleaseParcel = () => {
    const pendingParcels = this.props.parcelDetails.pending_parcels;
    const hasMultipleParcels = pendingParcels.length > 1;
    const parcelVerbiage = hasMultipleParcels ? 'parcels' : 'parcel';
    const hasOrHaveVerbiage = hasMultipleParcels ? 'have' : 'has';
    const parcelsToReleaseIDs = Object.keys(this.state.selectedParcels).filter(
      parcelUUID => this.state.selectedParcels[parcelUUID]
    );

    const parcelsForPickup = hasMultipleParcels
      ? parcelsToReleaseIDs
      : this.state.parcelsToReleaseIDs;

    return (
      <div className="row">
        <div className="row" style={{ marginTop: '10px' }}>
          <p style={{ fontSize: '13px', textAlign: 'center' }}>
            {this.props.parcelDetails.tenant_full_name}, by signing below, you verify that{' '}
            {parcelVerbiage}{' '}
            <b style={{ fontFamily: 'Circular-Bold', color: AccentColor() }}>
              {parcelsForPickup.join(', ')}
            </b>{' '}
            {hasOrHaveVerbiage} been received.
          </p>
        </div>

        <div className="row" style={{ width: 320, margin: '10px auto' }}>
          <div style={{ textAlign: 'center' }}>
            <SignatureCanvas
              penColor="black"
              ref={ref => {
                this.sigPad = ref;
              }}
              onEnd={() => {
                this.saveSignature();
              }}
              canvasProps={{
                width: 320,
                height: 160,
                className: 'signature-canvas',
              }}
            />
            <FlatButton
              label="Clear"
              type="button"
              onClick={this.clear}
              backgroundColor={colors.WHITE}
              hoverColor="grey"
              style={{
                color: AccentColor(),
                height: '40px',
                float: 'left',
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  renderMultipleParcelSelection = () => {
    const customizedMuiTheme = {
      overrides: {
        MuiCheckbox: {
          root: {
            color: '#00000047',
            display: 'flex',
          },
          colorSecondary: {
            '&$checked': {
              color: AccentColor(),
            },
          },
          colorPrimary: {
            '&$checked': {
              color: AccentColor(),
            },
          },
        },
        MuiFormControlLabel: {
          root: {
            display: 'flex',
          },
        },
        MuiTypography: {
          root: {
            fontFamily: 'Circular-Black !important',
            fontSize: '14px !important',
          },
        },
        MuiSvgIcon: {
          root: {
            fontSize: '22px',
          },
        },
      },
    };

    return (
      <div className="row" style={{ maxWidth: '300px', margin: '0 auto 30px' }}>
        <h5 style={{ textAlign: 'center' }}>Select the parcels you would like to release</h5>
        <MuiThemeProvider theme={createMuiTheme(customizedMuiTheme)}>
          {this.state.parcelsToReleaseIDs.map(parcelUUID => {
            return (
              <FormControlLabel
                style={{ marginBottom: '-10px' }}
                control={<Checkbox onChange={this.handleSelect(parcelUUID)} value={parcelUUID} />}
                label={parcelUUID}
              />
            );
          })}
        </MuiThemeProvider>
      </div>
    );
  };
};

let ParcelDetailsDialog = class AddParcelForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showReleaseParcel: false,
      parcelsToReleaseIDs: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.showReleaseParcel && !nextProps.isOpen) {
      this.toggleReleaseParcelDialog([]);
    }
  }

  toggleReleaseParcelDialog = parcelsToReleaseIDs => {
    this.setState({ parcelsToReleaseIDs, showReleaseParcel: !this.state.showReleaseParcel });
  };

  render() {
    const { parcelDetails } = this.props;

    return (
      <Dialog
        disableBackdropClick
        fullScreen={this.props.fullScreen}
        open={this.props.isOpen}
        onClose={this.props.toggleParcelDetailsDialog}
        aria-labelledby="add-new-parcel"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <DialogTitle id="add-new-parcel">
          <h3 style={{ textAlign: 'center', margin: 0 }}>
            Parcel {parcelDetails.uuid}{' '}
            <ParcelStatus parcelDetails={parcelDetails} style={style.statusBadge} />
          </h3>
        </DialogTitle>
        <DialogContent>
          <ParcelDetails
            parcelDetails={parcelDetails}
            toggleReleaseParcelDialog={this.toggleReleaseParcelDialog}
            showTenantDetails={this.props.showTenantDetails}
          />
          <ReleaseParcelForm
            parcelDetails={parcelDetails}
            toggleReleaseParcelDialog={this.toggleReleaseParcelDialog}
            parcelsToReleaseIDs={this.state.parcelsToReleaseIDs}
            isOpen={this.state.showReleaseParcel}
            saveSignature={this.props.saveSignature}
            releaseParcels={this.props.releaseParcels}
            fullScreen={this.props.fullScreen}
          />
        </DialogContent>
        <DialogActions style={{ display: 'block', padding: '0 10px' }}>
          <FlatButton
            onClick={this.props.toggleParcelDetailsDialog}
            id="close-button"
            style={{ color: AccentColor(), padding: '0 15px' }}
          >
            CLOSE
          </FlatButton>
          <FlatButton
            onClick={() => this.props.submit('add_parcel')}
            id="submit-button"
            style={{
              color: 'white',
              padding: '0 15px',
            }}
          >
            SAVE
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    parcelDetails: state.landlordParcels.parcelDetails,
  };
};

export default compose(
  connect(mapStateToProps, {
    saveSignature,
  })
)(ParcelDetailsDialog);
